module.exports = __webpack_public_path__ + "static/media/refresh.7afe67c2.svg";